module.exports = __webpack_public_path__ + "img/Wunderkerzen.281ca54f.svg";